import { createSvgIcon as createSvgIconMaterial } from '@mui/material/utils';
export const createSvgIcon = createSvgIconMaterial;